import React from 'react';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}
export function Modal({
  isOpen,
  onClose,
  title,
  children,
  footer,
  size = 'md'
}: ModalProps) {
  if (!isOpen) return null;
  const sizes = {
    sm: 'max-w-md',
    md: 'max-w-lg',
    lg: 'max-w-2xl',
    xl: 'max-w-4xl'
  };
  return <div className="fixed inset-0 z-50 overflow-y-auto" data-id="element-127">
      <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" data-id="element-128">
        <div className="fixed inset-0 transition-opacity" aria-hidden="true" data-id="element-129">
          <div className="absolute inset-0 bg-gray-500 opacity-75" onClick={onClose} data-id="element-130"></div>
        </div>

        <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true" data-id="element-131">
          &#8203;
        </span>

        <div className={`inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle w-full ${sizes[size]}`} data-id="element-132">
          <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4" data-id="element-133">
            <div className="flex justify-between items-start mb-4" data-id="element-134">
              <h3 className="text-lg leading-6 font-medium text-gray-900" id="modal-title" data-id="element-135">
                {title}
              </h3>
              <button onClick={onClose} className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none" data-id="element-136">
                <X className="h-6 w-6" data-id="element-137" />
              </button>
            </div>
            <div className="mt-2" data-id="element-138">{children}</div>
          </div>
          {footer && <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse" data-id="element-139">
              {footer}
            </div>}
        </div>
      </div>
    </div>;
}